export const BRAND = "瓜场";
export const SITE_NAME = "瓜场 · 实时吃瓜";
export const SITE_SLOGAN = "全网热搜，第一现场";
export const CONTACT_EMAIL = "hello@guachang.example";

export const NAV_LINKS = [
  { key: "top", label: "首页", href: "#top" },
  { key: "hot", label: "实时热搜", href: "#hot" },
  { key: "latest", label: "新鲜瓜讯", href: "#latest" },
  { key: "topic", label: "深度专题", href: "#topic" },
  { key: "guide", label: "吃瓜指南", href: "#guide" },
  { key: "faq", label: "常见问题", href: "#faq" },
  { key: "about", label: "关于瓜场", href: "#about" },
];

export const CATEGORIES = ["全部", "影视", "综艺", "娱乐圈", "主播", "社会", "音乐"] as const;

export interface HotItem {
  id: number;
  cat: string;
  title: string;
  brief: string;
  heat: string;
  trend: "up" | "down" | "flat";
}

export const hotList: HotItem[] = [
  { id: 1, cat: "影视", title: "暑期档口碑大片凭自来水口碑杀出重围", brief: "点映后评分一路走高，网友自发安利刷屏朋友圈。", heat: "3280万", trend: "up" },
  { id: 2, cat: "综艺", title: "热门综艺收官夜现场repo两极刷屏", brief: "有人意难平、有人被治愈，讨论度瞬间登顶。", heat: "2760万", trend: "up" },
  { id: 3, cat: "娱乐圈", title: "顶流巡演门票“秒空” 抢票风波再起", brief: "多平台卡顿、黄牛抬价，粉丝呼吁加大打击力度。", heat: "2490万", trend: "flat" },
  { id: 4, cat: "娱乐圈", title: "剧组“路透”视频疯传 工作室火速辟谣", brief: "未经证实的片段被断章取义，官方第一时间回应。", heat: "2180万", trend: "up" },
  { id: 5, cat: "主播", title: "一场直播带货翻车现场被全程围观", brief: "口播出错加供应链翻车，反向带货意外出圈。", heat: "1960万", trend: "down" },
  { id: 6, cat: "综艺", title: "新晋小童星舞台表现刷屏热搜", brief: "真实表现力打动观众，多个相关话题接连上榜。", heat: "1740万", trend: "up" },
  { id: 7, cat: "音乐", title: "音乐节阵容官宣 歌迷直呼“值回票价”", brief: "新老搭配的演出名单一经公布便冲上热榜。", heat: "1520万", trend: "flat" },
  { id: 8, cat: "影视", title: "老戏骨片场敬业细节被网友扒出", brief: "一句台词反复打磨的幕后片段获广泛点赞。", heat: "1330万", trend: "up" },
  { id: 9, cat: "社会", title: "网红餐厅排队四小时引热议", brief: "打卡经济与真实体验的落差，成为公共讨论点。", heat: "1180万", trend: "down" },
  { id: 10, cat: "影视", title: "国产悬疑剧结局彩蛋暗藏多重玄机", brief: "导演埋下的细节被逐帧复盘，二刷党集体出动。", heat: "986万", trend: "up" },
];

export interface PostItem {
  id: number;
  cat: string;
  title: string;
  excerpt: string;
  date: string;
  time: string;
  views: string;
  comments: string;
  img: string;
  alt: string;
}

export const latestPosts: PostItem[] = [
  {
    id: 1, cat: "影视", date: "2026-09-08", time: "刚刚更新", views: "32万", comments: "860",
    title: "《街边合唱团》口碑长跑，评论区为何全是“自来水”？",
    excerpt: "没有顶级流量、没有铺天盖地的宣发，这部作品却靠普通观众的一句句安利爬上了热搜。我们复盘它走红背后的口碑传导路径，聊聊真诚表达与观众情绪的同频。",
    img: "https://readdy.ai/api/search-image?query=street_choir_performing_at_warm_old_city_street_at_dusk_with_crowd_clapping_and_sunlight_flare%2C_cinematic_editorial_photography%2C_warm_coral_amber_tone%2C_film_grain%2C_shallow_depth&width=800&height=520&seq=latest-01&orientation=landscape",
    alt: "街边合唱团街头演出引发路人围观的热搜现场图",
  },
  {
    id: 2, cat: "娱乐圈", date: "2026-09-08", time: "2小时前", views: "28万", comments: "712",
    title: "演唱会“应援色”之争，是仪式感还是规训？",
    excerpt: "一片应援色海洋背后，藏着粉丝社群的组织逻辑与情感表达。当仪式感逐渐演变为一种被要求的“正确”，我们是否该重新审视追星的边界？",
    img: "https://readdy.ai/api/search-image?query=sea_of_glowing_lightsticks_at_indoor_concert_waving_in_dark_hall_with_warm_amber_and_coral_stage_lights%2C_editorial_photography%2C_atmospheric_haze%2C_cinematic_energy&width=800&height=520&seq=latest-02&orientation=landscape",
    alt: "演唱会现场挥舞荧光棒的应援色海洋",
  },
  {
    id: 3, cat: "综艺", date: "2026-09-07", time: "昨天", views: "24万", comments: "540",
    title: "一档素人恋综爆红，我们到底在看什么？",
    excerpt: "当屏幕里的不再是明星而是普通人，磕糖的快乐里也多了几分代入与共鸣。这份“上头”背后，折射出年轻人对亲密关系的真实想象。",
    img: "https://readdy.ai/api/search-image?query=two_people_sitting_at_romantic_rooftop_cafe_under_warm_string_lights_looking_at_each_other%2C_blurred_city_night_background%2C_cinematic_editorial_photography%2C_warm_tone&width=800&height=520&seq=latest-03&orientation=landscape",
    alt: "恋综里黄昏天台咖啡馆约会的温馨场景",
  },
  {
    id: 4, cat: "影视", date: "2026-09-07", time: "昨天", views: "21万", comments: "433",
    title: "“剧透式营销”越来越卷，观众还愿意买单吗？",
    excerpt: "预告越剪越猛、物料越放越早，高能片段几乎被剧透殆尽。当悬念成为宣发牺牲品，走进影院的我们还剩下多少未知的惊喜？",
    img: "https://readdy.ai/api/search-image?query=film_clapperboard_and_popcorn_on_cinema_seat_in_front_of_glowing_cinema_screen_with_warm_light%2C_cinematic_editorial_photography%2C_cozy_ambience&width=800&height=520&seq=latest-04&orientation=landscape",
    alt: "电影院座位上摆着场记板与爆米花的观影氛围",
  },
  {
    id: 5, cat: "主播", date: "2026-09-06", time: "前天", views: "19万", comments: "380",
    title: "主播反向带货翻红：真诚为什么成了流量密码？",
    excerpt: "有人靠话术套路卖货，有人却因一句大实话意外走红。当观众对夸张推销越来越警惕，“真诚”反而成为最稀缺也最值钱的竞争力。",
    img: "https://readdy.ai/api/search-image?query=content_creator_talking_to_smartphone_on_ring_light_setup_in_warm_home_studio_with_packages%2C_bright_clean_editorial_photography%2C_warm_light_tone&width=800&height=520&seq=latest-05&orientation=landscape",
    alt: "主播在暖色调家庭直播间里直播带货的画面",
  },
  {
    id: 6, cat: "社会", date: "2026-09-06", time: "3天前", views: "16万", comments: "295",
    title: "非遗手艺人的直播间，把老手艺“盘”活了",
    excerpt: "从濒临失传到订单接到手软，一根网线让传统技艺走进了年轻人的生活。手艺人的坚守与时代的流量，在直播间里奇妙相遇。",
    img: "https://readdy.ai/api/search-image?query=artisan_crafting_intricate_handicraft_with_his_hands_at_workshop_desk_under_warm_light_with_tools%2C_close_up_editorial_photography%2C_documentary_warm_tone&width=800&height=520&seq=latest-06&orientation=landscape",
    alt: "手工艺人在暖光工作台前专注制作传统手工的画面",
  },
  {
    id: 7, cat: "影视", date: "2026-09-05", time: "4天前", views: "14万", comments: "252",
    title: "电影宣发整活大赏：海报、路透与热搜话术",
    excerpt: "一张出圈海报、一段高光路透、一句洗脑 slogan……我们盘点今年最具记忆点的电影宣发案例，看创意如何四两拨千斤。",
    img: "https://readdy.ai/api/search-image?query=collage_of_film_poster_designs_and_colorful_marketing_stickers_on_creative_desk_with_warm_studio_light%2C_editorial_design_photography%2C_vibrant_warm_palette&width=800&height=520&seq=latest-07&orientation=landscape",
    alt: "摆满电影海报与营销贴纸的创意设计桌面",
  },
  {
    id: 8, cat: "音乐", date: "2026-09-05", time: "5天前", views: "11万", comments: "188",
    title: "热门单曲洗脑循环背后，短视频的“15秒魔咒”",
    excerpt: "副歌一响、手指自动抬起。当一首歌只为那十五秒而生，完整的音乐叙事是否正在被流量重塑？我们聊聊算法与创作。",
    img: "https://readdy.ai/api/search-image?query=headphones_and_smartphone_with_audio_equalizer_waves_on_warm_wooden_desk_with_coffee%2C_cozy_morning_light%2C_editorial_photography%2C_music_theme_warm_tone&width=800&height=520&seq=latest-08&orientation=landscape",
    alt: "暖光书桌上耳机与手机播放音乐波形的创作氛围",
  },
];

export interface TopicItem {
  id: number;
  kicker: string;
  title: string;
  excerpt: string;
  readTime: string;
  img: string;
  alt: string;
}

export const topics: TopicItem[] = [
  {
    id: 1, kicker: "深度观察", readTime: "8 分钟", title: "热搜不是全部：吃瓜的正确打开方式",
    excerpt: "从一条热搜到另一个热搜，舆论总是瞬息万变。与其被动地被话题牵着走，不如学会主动筛选、冷静求证、理性表达。本文分享如何在海量瓜讯中守住判断力，做个清醒而不失乐趣的围观者。",
    img: "https://readdy.ai/api/search-image?query=magnifying_glass_over_colorful_newspaper_headlines_and_phone_screen_with_news_feed_on_warm_desk%2C_editorial_flatlay_photography%2C_warm_light%2C_sharp_focus&width=1000&height=620&seq=topic-01&orientation=landscape",
    alt: "放大镜审视手机新闻信息流与报纸头条的深度观察配图",
  },
  {
    id: 2, kicker: "年度盘点", readTime: "10 分钟", title: "反转又反转：今年那些高开低走的瓜",
    excerpt: "年初的瓜吃到年尾，剧情早已换了几个版本。我们按时间线梳理了几起贯穿全年的“连续剧”式事件，看话题如何一次次反转，也看当事人与舆论如何在拉扯中走向平息。",
    img: "https://readdy.ai/api/search-image?query=timeline_with_photo_pins_and_red_thread_on_warm_wall_looking_like_investigation_board%2C_editorial_photography%2C_dramatic_warm_light%2C_soft_shadow&width=1000&height=620&seq=topic-02&orientation=landscape",
    alt: "用照片图钉与红线串联时间线的年度瓜事盘点图",
  },
  {
    id: 3, kicker: "消费观察", readTime: "6 分钟", title: "从路透到带货：流量经济的生意经",
    excerpt: "一部剧、一场巡演、一句出圈台词，都能在极短时间内被转化为真金白银。娱乐内容与消费的距离越来越近，背后的商业逻辑值得每一个观众看懂。",
    img: "https://readdy.ai/api/search-image?query=shopping_bags_and_merchandise_boxes_next_to_social_media_icons_drawn_on_warm_background%2C_editorial_product_photography%2C_clean_warm_composition&width=1000&height=620&seq=topic-03&orientation=landscape",
    alt: "购物袋与周边商品搭配社交媒体图标的流量经济观察图",
  },
];

export interface GuideItem {
  icon: string;
  title: string;
  text: string;
}

export const guides: GuideItem[] = [
  { icon: "ri-file-search-line", title: "先问“谁说的、有无出处”", text: "看到爆料先别急着冲，回到源头核对发布者与原始信源，截图与视频是否存在断章取义。给传播按下一次暂停键。" },
  { icon: "ri-time-line", title: "用时间差给情绪降噪", text: "热点发酵最快的一小时情绪最浓。等消息沉淀几小时后，很多“实锤”会自动现出原形，冷静一点能少踩不少坑。" },
  { icon: "ri-search-eye-line", title: "善用关键词交叉验证", text: "把核心信息拆成几个关键词多平台检索，对比不同账号的说法。多方印证一致的，可信度往往更高。" },
  { icon: "ri-heart-2-line", title: "做有边界的旁观者", text: "吃瓜归吃瓜，不打扰、不网暴、不扩散隐私。理性吃瓜是尊重每一个真实的人，也守护自己的表达边界。" },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqs: FaqItem[] = [
  { q: "瓜场的热搜榜多久更新一次？", a: "热搜榜会随全网话题热度实时刷新，热门事件通常以分钟级更新，其余板块按小时滚动整理，确保大家尽量第一时间看到正在发酵的瓜。" },
  { q: "看到的信息是真是假，平台会核实吗？", a: "我们会优先整理带有明确信源、多方印证的消息，并在标题与摘要中提示信源状态。涉及未经证实的爆料，会标注“待证实”，供你判断，而非替你下结论。" },
  { q: "我想投稿或提供线索，怎么联系？", a: "欢迎通过页面底部的联系邮箱给我们发来线索。投稿请尽量附上信源链接或截图，收到后我们会按流程核实，并选择有公共讨论价值的内容进行跟进。" },
  { q: "内容会不会侵犯当事人隐私？", a: "不会。我们只围绕已公开、可公开讨论的话题整理资讯，不转载、不扩散个人隐私与未经许可的影像，始终把尊重当事人放在第一位。" },
  { q: "能否转载或引用瓜场的内容？", a: "欢迎在注明出处的前提下进行合理引用。商业转载或大篇幅转载，请提前通过页面底部的邮箱与我们取得联系，获得授权后再使用。" },
  { q: "移动端上浏览体验如何？", a: "站点针对手机、平板与电脑都做了适配，导航可折叠、榜单可横向滑动，方便你在地铁、午休或摸鱼时也能轻松吃瓜。" },
];

export interface VoiceItem {
  name: string;
  role: string;
  text: string;
  tag: string;
}

export const voices: VoiceItem[] = [
  { name: "阿北", role: "追剧十年老粉", tag: "追更党", text: "最方便的一点是热点更新够快，中午午休刷一眼，晚上聊天我基本都能接上话，不用再去各个平台翻。", },
  { name: "小鹿爱吃瓜", role: "媒体从业者", tag: "行业观察", text: "作为同行我挺看重信源提示，能看到哪些是实锤哪些还待证，这个分寸感拿捏得不错，省了我不少核对时间。", },
  { name: "老周", role: "80后程序员", tag: "理性派", text: "以前刷信息流容易越刷越焦虑，瓜场的吃瓜指南提醒我先求证再转发，现在心态稳多了，评论区氛围也舒服。", },
  { name: "一一", role: "大二学生", tag: "冲浪选手", text: "页面很好看，榜单滑着很顺，专题写得也有点东西，不是那种标题党。半夜失眠也能安静地看两篇。", },
];

export const faqPageItems: { question: string; answer: string }[] = [
  { question: faqs[0].q, answer: faqs[0].a },
  { question: faqs[1].q, answer: faqs[1].a },
  { question: faqs[2].q, answer: faqs[2].a },
];